import {
  FETCH_RECEIVEPAYMENT_REQUEST,
  FETCH_RECEIVEPAYMENT_SUCCESS,
  FETCH_RECEIVEPAYMENT_FAILURE,
} from "./receivePaymentDetailsTypes";
import api from "../../utils/Api";

export const receiveInvoiceDetailsRequest = () => {
  return {
    type: FETCH_RECEIVEPAYMENT_REQUEST,
  };
};

export const receiveInvoiceDetailsSuccess = (receivePaymentDetails) => {
  return {
    type: FETCH_RECEIVEPAYMENT_SUCCESS,
    payload: receivePaymentDetails,
  };
};

export const receiveInvoiceDetailsFailure = (error) => {
  return {
    type: FETCH_RECEIVEPAYMENT_FAILURE,
    payload: error,
  };
};

export const receiveInvoiceDetails = (payee_id, payer_id) => {
  const headers = {
    Authorization:
      "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
  };
  return async (dispatch) => {
    dispatch(receiveInvoiceDetailsRequest());
    try {
      const response = await api.get(
        "payment/account/detail?payee_id=" + payee_id + "&payer_id=" + payer_id,
        {
          headers: headers,
        }
      );
      const receivePaymentDetails = response.data.data;

      dispatch(receiveInvoiceDetailsSuccess(receivePaymentDetails));
    } catch (error) {
      console.log("Redux error - ", error.response);
      const errorMsg = error.message;
      dispatch(receiveInvoiceDetailsFailure(errorMsg));
    }
  };
};
